<template>
  <Modal
    v-model="isOpen"
    title="キャリアカウンセリングを受けてみませんか？"
    :show-title="true"
    :show-title-icon="true"
    title-icon-type="agent"
    :show-close="true"
    :close-on-backdrop="true"
    :close-on-esc="true"
    :auto-focus="false"
    body-padding="0"
    :max-width="640"
    @close="handleClose"
  >
    <div :class="$style.modalDirectGuideModal">
      <div :class="$style.seWrapper">
        <div :class="$style.se">
          <p v-for="message in AGENT_SERVICE_GUIDE_MESSAGES" :key="message" :class="$style.message">
            {{ message }}
          </p>
        </div>
      </div>
    </div>
    <template #footer>
      <div :class="$style.buttonWrapper">
        <Button
          variant="primary"
          button-style="filled"
          :custom-size="true"
          class="px-24x py-12x"
          :to="TEASER_PATH"
          @click="capturePrePathOfTeaser"
        >
          <span :class="$style.paragraph">
            <b :class="$style.b2">エージェントサービスのご紹介</b>
          </span>
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import Button from '@/components/shared/button/Button.vue';
import { AGENT_SERVICE_GUIDE_MESSAGES } from '@/components/shared/modal/agentServiceGuideMessages';
import { TEASER_PATH } from '@/constant/routers/path';
import { computed } from 'vue';
import Modal from './Modal.vue';
import type { GuideModalBaseProps } from './types.d';

const props = defineProps<GuideModalBaseProps>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
  (e: 'close'): void;
}>();

const isOpen = computed({
  get: () => props.modelValue,
  set: (value: boolean) => {
    emit('update:modelValue', value);
  },
});

const capturePrePathOfTeaser = (): void => {
  localStorage.setItem('prePathOfTeaser', `${window.location.pathname}${window.location.search}`);
};

const handleClose = (): void => {
  isOpen.value = false;
};
</script>

<style module>
.modalDirectGuideModal {
  width: 100%;
  position: relative;
  border-radius: 12px;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-align: left;
  font-size: 14px;
  color: #fff;
  font-family: Inter, sans-serif;
}
.seWrapper {
  align-self: stretch;
  overflow: hidden;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 40px;
  padding-bottom: 12px;
  padding-inline: 24px;
  color: #000;
}
.se {
  align-self: stretch;
  position: relative;
  letter-spacing: 0.55px;
  line-height: 20px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.message {
  margin: 0;
}
.buttonWrapper {
  align-self: stretch;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 0px;
  text-align: center;
}
.paragraph {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.b2 {
  position: relative;
  letter-spacing: 0.55px;
  line-height: 21px;
}
</style>
